export default "__VITE_ASSET__BPdvi$LA__"